import React from 'react';
import { ResponsibleForUnitContainerProps } from './types';
import { ResponsibleForUnitCard } from './responsible-for-unit-card';
import { TileWrapper } from 'app/components/tile-wrapper/tile-wrapper';
import { GroupText } from 'app/components/group-text/group-text';

export const ResponsibleForUnitContainer: React.FC<ResponsibleForUnitContainerProps> = ({
  valueItems = [], validation, translation
}) => {

  const shouldRender = Array.isArray(valueItems) && valueItems.length > 0;

  return <div className="row">
    <div className="col-md-12">
      <TileWrapper>
        <GroupText>{translation.responsible_for_unit_title}</GroupText>
        {shouldRender &&
          <div className="row">
            {valueItems.map((item, index) =>
              <ResponsibleForUnitCard
                key={index}
                label={item.description}
                values={item.values}
                translation={translation}
                validation={validation} />)}
          </div>}
      </TileWrapper>
    </div>
  </div>;
};
